import { useState } from "react";
import { ChevronLeft, ChevronRight, RotateCcw } from "lucide-react";

const ParentLabel = () => <span className="inline-flex rounded-full bg-bt-primary px-4 py-1.5 text-sm font-bold uppercase tracking-[0.15em] text-bt-bg">Parent</span>;
const ChildLabel = () => <span className="inline-flex rounded-full border-2 border-bt-primary bg-bt-sage px-4 py-1 text-sm font-bold uppercase tracking-[0.15em] text-bt-primary">Child</span>;

export function PairsList({ pairs }) {
  return (
    <ol className="space-y-5" data-testid="pairs-list">
      {pairs.map((p, i) => (
        <li key={i} className="card-bt p-6 sm:p-8">
          <ParentLabel />
          <p className="mt-3 font-heading text-2xl leading-snug text-bt-heading sm:text-3xl">{p.parent}</p>
          <div className="mt-6"><ChildLabel /></div>
          <p className="mt-3 text-2xl font-bold leading-snug text-bt-primary sm:text-3xl">{p.child}</p>
        </li>
      ))}
    </ol>
  );
}

export function PairsReader({ pairs }) {
  const [i, setI] = useState(0);
  const [reveal, setReveal] = useState(false);
  const p = pairs[i];
  const last = i === pairs.length - 1;
  const next = () => {
    if (!reveal) return setReveal(true);
    if (!last) {
      setI(i + 1);
      setReveal(false);
    }
  };
  const prev = () => {
    if (i > 0) {
      setI(i - 1);
      setReveal(true);
    }
  };
  return (
    <div className="rounded-[32px] bg-bt-sage p-6 sm:p-10" data-testid="pairs-reader">
      <div className="mb-6 flex items-center justify-between text-sm font-semibold text-bt-sagedeep">
        <span data-testid="pairs-reader-progress">{i + 1} of {pairs.length}</span>
        <div className="flex gap-1.5">
          {pairs.map((_, j) => <span key={j} className={`h-2 rounded-full transition-[width,background-color] duration-300 ${j === i ? "w-6 bg-bt-primary" : "w-2 bg-bt-border"}`} />)}
        </div>
      </div>
      <div key={i} className="fade-up min-h-[260px]">
        <ParentLabel />
        <p className="mt-4 font-heading text-3xl leading-tight text-bt-heading sm:text-4xl" data-testid="pairs-reader-parent">{p.parent}</p>
        <div className={`mt-8 transition-opacity duration-500 ${reveal ? "opacity-100" : "opacity-0"}`}>
          <ChildLabel />
          <p className="mt-4 text-3xl font-bold leading-tight text-bt-primary sm:text-5xl" data-testid="pairs-reader-child">{p.child}</p>
        </div>
      </div>
      <div className="mt-8 flex items-center gap-3">
        <button onClick={prev} disabled={i === 0} className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-bt-primary text-bt-primary disabled:opacity-30" aria-label="Previous" data-testid="parent-child-prev-button">
          <ChevronLeft />
        </button>
        {last && reveal ? (
          <button onClick={() => { setI(0); setReveal(false); }} className="btn-primary flex-1" data-testid="parent-child-restart-button">
            <RotateCcw size={18} /> Start again
          </button>
        ) : (
          <button onClick={next} className="btn-primary flex-1 text-lg" data-testid="parent-child-next-button">
            {reveal ? "Next question" : "Show child's answer"} <ChevronRight size={20} />
          </button>
        )}
      </div>
    </div>
  );
}
